import { Theme, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles<Theme>((theme) => ({
  root: () => ({
    fontFamily: theme.typography.fontFamily,
    cursor: "pointer",
    color: theme.palette.blue.darkShade1,
  }),
}));
